import React from 'react';

const ShippingOne = () => {
  return (
    <section className="shipping mb-24 bg-main-600 text-white mt-24" id="shipping">
      <div className="container">
        <div className="row text-center">
          {/* 100+ Vendors */}
          <div className="col-6 col-md-3">
            <div className="d-flex flex-column align-items-center justify-content-center py-3">
              <span className="mb-2">
                <i
                  className="ph-fill ph-storefront"
                  style={{ fontSize: '2rem' }}
                />
              </span>
              <h6 className="mb-1 text-white">100+ Vendors</h6>
              <p className="small mb-0">
                Wide range of choices from top vendors
              </p>
            </div>
          </div>
          {/* Trusted Warranty */}
          <div className="col-6 col-md-3">
            <div className="d-flex flex-column align-items-center justify-content-center py-3">
              <span className="mb-2">
                <i
                  className="ph-fill ph-shield-check"
                  style={{ fontSize: '2rem' }}
                />
              </span>
              <h6 className="mb-1 text-white">Trusted Warranty</h6>
              <p className="small mb-0">
                Quality assured with reliable warranties
              </p>
            </div>
          </div>
          {/* Express Delivery */}
          <div className="col-6 col-md-3">
            <div className="d-flex flex-column align-items-center justify-content-center py-3">
              <span className="mb-2">
                <i
                  className="ph-fill ph-truck"
                  style={{ fontSize: '2rem' }}
                />
              </span>
              <h6 className="mb-1 text-white">Express Delivery</h6>
              <p className="small mb-0">
                Fast &amp; reliable delivery service
              </p>
            </div>
          </div>
          {/* Customer Support */}
          <div className="col-6 col-md-3">
            <div className="d-flex flex-column align-items-center justify-content-center py-3">
              <span className="mb-2">
                <i
                  className="ph-fill ph-headset"
                  style={{ fontSize: '2rem' }}
                />
              </span>
              <h6 className="mb-1 text-white">Customer Support</h6>
              <p className="small mb-0">
                24/7 expert support for your needs
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShippingOne;
